<template>
  <div class="agency-service">
    <SiruiSearch
      v-if="instructStatus && turnType === '3'"
      :query="agencyDetailData"
      labelWidth="110px"
      :columns="agencyDetailForm"
      :isQueryPanel="false"
      isDisabledForm="true"
    ></SiruiSearch>
    <SiruiSearch
      v-else
      ref="agencyServiceRef"
      :query="agencyServiceForm"
      labelWidth="110px"
      :columns="agencyQueryColumn"
      :isQueryPanel="false"
      :rules="agencyDataRules"
      @handleAgencyChange="handleAgencyChange"
    ></SiruiSearch>
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button
          @click="add"
          v-if="turnType === '0' || turnType === '2'"
          type="primary"
          :disabled="disabledFlag"
          >新建服务</el-button
        >
        <el-button @click="edit" v-if="turnType === '1'" type="primary" :disabled="disabledFlag"
          >编辑服务</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      align="left"
      show-header-overflow
      :auto-resize="true"
      border
      resizable
      show-overflow
      highlight-hover-row
      size="mini"
      ref="agencyServiceTable"
      class="vxe-table-element"
      :data="tableData"
      :max-height="$store.state.app.tableHeight"
      @select-change="handleSelectionChange"
    >
      <vxe-table-column
        v-for="(item, index) in turnType === '3' ? agencyDetailColumn : agencyColumn"
        :key="index"
        :type="item.type"
        :visible="item.visible"
        :fixed="item.fixed"
        :width="item.width"
        :field="item.field"
        :title="item.title"
      >
      </vxe-table-column>
    </vxe-table>
    <AddAgencyDialog
      v-if="agencyDialogVisible"
      ref="addAgencyDialogRefs"
      :title="title"
      @submit="submit"
      :agencyDialogVisible="agencyDialogVisible"
      :isEdit="isEdit"
      :contractCode="contractCode"
      :editFormValue="editFormValue"
      :addContainerType="addContainerType"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
  import XEUtils from 'xe-utils';
  import SiruiSearch from '@/components/SiruiSearch';
  import {
    agencyFormColumn,
    agencyColumn,
    agencyDetailColumn,
    agencyDetailForm,
    orderStatusList,
  } from '../data';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import AddAgencyDialog from './addAgencyDialog';
  import bus from '@/common/js/bus';
  export default {
    name: 'agencyService',
    mixins: [orderMixin],
    props: ['contractRelationInfo', 'transAgencyArr', 'turnType', 'currStatus', 'checkedRailList'],
    components: {
      SiruiSearch,
      AddAgencyDialog,
    },
    data() {
      return {
        agencyServiceForm: {
          purchaseOrgName: '', // 合同带出
          serviceProviderName: '',
          serviceProviderCode: '',
          bookingRequire: '', // 合同带出
          departurePlaceCode: '', // 启运站编码
          departurePlaceName: '', // 启运站
          departureProvinceCode: '', // 启运站省份编码
          departureProvinceName: '', // 启运站省份
          destinationCode: '', // 到达站编码
          destinationName: '', // 到达站
          destinationProvinceCode: '', // 到达站省份编码
          destinationProvince: '', // 到达站省份
          roughWeight: '', // 毛重
          roughWeightUnit: '', // 毛重单位
        },
        agencyDetailData: {
          instructCode: '',
          purchaseOrgName: '',
          serviceProviderName: '',
          instructStatus: '',
          instructIssueDate: '',
          instructUpdateDate: '',
          classType: '',
          bookingRequire: '',
          departurePlaceName: '',
          departureProvinceName: '',
          destinationName: '',
          destinationProvince: '',
          roughWeight: '', // 毛重
          roughWeightUnit: '', // 毛重单位
          businessComplatedDate: '', // 完结时间
        },
        agencyColumn,
        agencyDetailColumn,
        multipleSelection: [],
        tableData: [],
        serviceProviderList: [],
        provinceList: [],
        agencyDialogVisible: false,
        instructStatus: '',
        agencyDetailForm,
        orderStatusList,
        agencyList: [],
        editFormValue: {},
        isEdit: false,
        title: '',
        addContainerType: '',
        selectXID: '',
        // stationList: [],
        contractCode: null,
      };
    },
    computed: {
      agencyQueryColumn() {
        return agencyFormColumn(this);
      },
      disabledFlag() {
        if (this.checkedRailList?.includes('6')) {
          return false;
        }
        return this.turnType === '3' || (this.turnType === '1' && this.instructStatus !== 'draft');
      },
      agencyDataRules() {
        return {
          serviceProviderCode: [{ required: true, message: '服务供方必选', trigger: 'change' }],
          roughWeight: [{ required: true, message: '毛重必填', trigger: 'change' }],
          roughWeightUnit: [
            { required: true, message: '毛重单位必选', trigger: ['change', 'blur'] },
          ],
          departurePlaceName: [{ required: true, message: '启运站必选', trigger: 'change' }],
          departureProvinceCode: [{ required: true, message: '启运站省份必选', trigger: 'change' }],
          destinationName: [{ required: true, message: '到达站必选', trigger: 'change' }],
          destinationProvinceCode: [
            { required: true, message: '到达站省份必选', trigger: 'change' },
          ],
        };
      },
    },
    watch: {
      contractRelationInfo(val) {
        if (val) {
          this.contractRelationInfo = val;
          if (val.contractCode && val.contractCode?.length != 0) {
            this.contractCode = val.contractCode;
            this.clearAll();
          }
          this.initData();
        }
      },
      transAgencyArr(val) {
        setTimeout(() => {
          if (val) {
            this.transAgencyArr = val;
            if (this.turnType === '3' || this.turnType === '1' || this.turnType === '2') {
              this.agencyDetail();
            }
          }
        }, 1000);
      },
    },
    created() {
      this.getServiceProviderList();
      this.getWeightUnitList();
      this.getProvinceList();
      // this.getStationList();
      bus.$on('baseBoxList', (data) => {
        let boxList = data;
        this.initTableData(boxList);
      });
    },
    mounted() {
      this.initData();
    },
    methods: {
      clearAll() {
        this.tableData = [];
      },
      agencyDetail() {
        const transAgencyObj = this.transAgencyArr[0] || {};
        console.log(transAgencyObj, 'transAgencyObj');
        this.instructStatus = transAgencyObj.instructStatus || '';
        this.tableData = [];
        if (this.instructStatus && this.turnType === '3') {
          const detailObj = {
            instructCode: transAgencyObj.instructCode,
            purchaseOrgName: transAgencyObj.purchaseOrgName,
            serviceProviderName: transAgencyObj.serviceProviderName,
            // serviceProviderName: this.transferSelect(
            //   transAgencyObj.serviceProviderCode,
            //   this.serviceProviderList,
            //   'supplierCode',
            //   'supplierName'
            // ),
            instructStatus: this.transferSelect(
              transAgencyObj.instructStatus,
              this.orderStatusList
            ),
            instructIssueDate: transAgencyObj.instructIssueDate,
            instructUpdateDate: transAgencyObj.instructUpdateDate,
            classType: transAgencyObj.classType,
            bookingRequire: transAgencyObj.bookingRequire,
            departurePlaceCode: transAgencyObj.departurePlaceCode,
            departurePlaceName: transAgencyObj.departurePlaceName,
            departureProvinceName: transAgencyObj.departureProvinceName,
            destinationName: transAgencyObj.destinationName,
            destinationProvince: transAgencyObj.destinationProvince,
            departureProvinceCode: transAgencyObj.departureProvinceCode,
            destinationProvinceCode: transAgencyObj.destinationProvinceCode,
            destinationCode: transAgencyObj.destinationCode,
            roughWeight: transAgencyObj.roughWeight,
            // roughWeightUnit: transAgencyObj.roughWeightUnit,
            roughWeightUnit: this.transferSelect(
              transAgencyObj.roughWeightUnit,
              this.weightUnitList
            ),
            businessComplatedDate: transAgencyObj.businessComplatedDate,
          };
          Object.assign(this.agencyDetailData, detailObj);
        } else {
          // const obj = {
          //   purchaseOrgName: transAgencyObj.purchaseOrgName,
          //   serviceProviderName: transAgencyObj.serviceProviderName,
          //   serviceProviderCode: transAgencyObj.serviceProviderCode,
          //   bookingRequire: transAgencyObj.bookingRequire,
          //   departurePlaceCode: transAgencyObj.departurePlaceCode,
          //   departurePlaceName: transAgencyObj.departurePlaceName,
          //   departureProvinceCode: transAgencyObj.departureProvinceCode,
          //   departureProvinceName: transAgencyObj.departureProvinceName,
          //   destinationCode: transAgencyObj.destinationCode,
          //   destinationName: transAgencyObj.destinationName,
          //   destinationProvinceCode: transAgencyObj.destinationProvinceCode,
          //   destinationProvince: transAgencyObj.destinationProvince,
          //   roughWeight: transAgencyObj.roughWeight,
          //   roughWeightUnit: transAgencyObj.roughWeightUnit,
          // };
          const obj = transAgencyObj;
          Object.assign(this.agencyServiceForm, obj);
        }

        // (transAgencyObj.truckContainers || []).forEach((truck) => {
        //   this.tableData.push(truck);
        // });
        this.tableData = transAgencyObj.truckContainers || [];
      },
      initData() {
        this.agencyServiceForm.purchaseOrgName = this.contractRelationInfo.saleDepartmentName;
      },
      initTableData(boxList) {
        this.tableData = [];
        boxList.forEach((box) => {
          console.log(box.type, box.number, 'box.type');
          for (let i = 0; i < box.number; i++) {
            this.tableData.push({
              rentDate: '',
              containerType: box.type,
              tranStartDate: '',
              productName: '',
              remarks: '',
            });
          }
        });
      },
      add() {
        if (
          !this.contractRelationInfo?.contractCode ||
          this.contractRelationInfo?.contractCode?.length == 0
        ) {
          this.$message({
            showClose: true,
            message: '请先选择客户合同',
            type: 'error',
          });
          return;
        }
        const selectRecords = this.$refs.agencyServiceTable.getCheckboxRecords();
        console.log(selectRecords, 'selectRecords');
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selectRecords.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能新建一条服务',
            type: 'error',
          });
        } else {
          this.agencyDialogVisible = true;
          this.title = '新增铁路运输服务';
          this.addContainerType = selectRecords[0].containerType;
          this.isEdit = false;
        }
      },
      edit() {
        if (!this.contractCode || this.contractCode?.length == 0) {
          this.$message({
            showClose: true,
            message: '请先选择客户合同',
            type: 'error',
          });
          return;
        }
        const selectRecords = this.$refs.agencyServiceTable.getCheckboxRecords();
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selectRecords.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能编辑一条服务',
            type: 'error',
          });
        } else {
          this.$nextTick(() => {
            this.agencyDialogVisible = true;
            this.title = '编辑铁路运输服务';
            this.isEdit = true;
            this.editFormValue = selectRecords[0] || {};
            console.log(this.editFormValue, 'this.editFormValue');
          });
        }
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
        if (row.selection.length === 1) {
          this.selectXID = row.selection[0]._XID;
        }
        this.agencyList = row.selection || [];
      },
      submit(obj) {
        // this.agencyServiceForm.serviceProviderName = this.transferSelect(
        //   this.agencyServiceForm.serviceProviderCode,
        //   this.serviceProviderList,
        //   'partnerCode',
        //   'partnerZhName'
        // );
        // this.agencyServiceForm.departureProvinceName = this.transferSelect(
        //   this.agencyServiceForm.departureProvinceCode,
        //   this.provinceList
        // );
        // this.agencyServiceForm.destinationProvince = this.transferSelect(
        //   this.agencyServiceForm.destinationProvinceCode,
        //   this.provinceList
        // );
        this.tableData.forEach((table) => {
          if (table._XID === this.selectXID) {
            Object.assign(table, obj);
          }
        });
      },
      closeDialog() {
        this.addContainerType = '';
        this.agencyDialogVisible = false;
        this.title = '';
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      handleAgencyChange(row) {
        console.log(row, '111');
        // if (row.prop === 'departurePlaceCode') {
        //   this.stationList.forEach((item) => {
        //     if (item.stationCode === row.val) {
        //       console.log(item, '111');
        //       this.agencyServiceForm.departurePlaceCode = item.stationCode;
        //       this.agencyServiceForm.departurePlaceName = item.stationName;
        //       this.agencyServiceForm.departureProvinceCode = item.stationProvinceCode;
        //       this.agencyServiceForm.departureProvinceName = item.stationProvinceName;
        //     }
        //   });
        // }
        // if (row.prop === 'destinationCode') {
        //   this.stationList.forEach((item) => {
        //     if (item.stationCode === row.val) {
        //       this.agencyServiceForm.destinationCode = item.stationCode;
        //       this.agencyServiceForm.destinationName = item.stationName;
        //       this.agencyServiceForm.destinationProvinceCode = item.stationProvinceCode;
        //       this.agencyServiceForm.destinationProvince = item.stationProvinceName;
        //     }
        //   });
        // }
        if (row.prop === 'serviceProviderCode') {
          console.log(this.serviceProviderList, 'this.serviceProviderList');
          this.agencyServiceForm.serviceProviderName = this.transferSelect(
            this.agencyServiceForm.serviceProviderCode,
            this.serviceProviderList,
            'supplierCode',
            'supplierName'
          );
        }
      },
    },
  };
</script>
